// import { GatsbyImage } from "gatsby-plugin-image"
import React from 'react'
import './styles/SpeakerSmallTag.scss'

const SpeakerSmallTag = (props) => {

    return (
        <div class="speakersTags">
            {props.info.map(s => (
                <div className="speaker schedule-refresh-speaker" key={s.fullName.toString()}>
                    <div className="img-wrapper schedule-refresh-image">{s.profilePicture && <img alt={s.fullName} src={s.profilePicture} />}</div>
                    <div className="txt-wrapper">
                        <div className="name">{s.fullName}</div>
                        <div className="tagline">{s.tagLine}</div>
                    </div>
                </div>
            ))}
        </div>
        
    )
}

export default SpeakerSmallTag